<div class="sidenav_container">
    <div fxLayout="column" fxLayoutGap="10px" style="height: 100%;">
        <div>
            <mat-nav-list>
                <div *ngIf="patient.patientid != -1">
                    <a mat-list-item *ngFor="let menu of userConfig.contentMenus" (click)="menuClick(menu);">
                        <fa-icon [icon]="menu.pwa?.icon" [styles]="menu.pwa?.icon_style" size="lg" [matTooltip]="menu.label"></fa-icon>
                    </a>
                </div>
            </mat-nav-list>
          </div>      
    </div>
</div>
